<script setup lang="ts">
import {Model} from "@/app/Model";
import type {TestoResult} from "@/app/data/TestoResult";
let model: Model = Model.getReactiveInstance();

function formatDettaglio( result: TestoResult): string {
  let outText: string = "";
  if (result.testo.length>0) {
    outText += `<h3>${result.testo[0].estremi}</h3>`;
    result.testo.forEach((testo: any): void => {
      outText += `<p>${testo.testo}</p>`;
    })
  }
  return outText;
}
</script>

<template>
  <!-- Modal -->
  <div class="modal fade" id="dettaglioModal" tabindex="-1" aria-labelledby="dettaglioModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body text-center" id="dettaglioModalContent">
            <div class="dettaglioTesto" v-if="model.testo_result.testo.length > 0" v-html="formatDettaglio(model.testo_result)">
            </div>
            <div class="dettaglioSpinner" v-else>
              <div class="d-flex justify-content-center" >
                <div class="spinner-border text-secondary" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>
            </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-secondary" data-bs-dismiss="modal">Chiudi</button>
        </div>
      </div>
    </div>
  </div>

</template>
